import { useState, useEffect } from "react";

import CustomLabel from "@/components/inputs/CustomLabel";
import CustomSelect from "@/components/inputs/CustomSelect";

import { getEmployeesOptions } from "@/api/employees";
import { getFullName } from "@/utils";

const InputEmployee = ({
  value,
  label,
  placeholder = "Начните вводить",
  returnObject = false,
  onSubmit,
  onKeyDown,
  onComplete,
}) => {
  const [val, setVal] = useState(value?.uuid);
  const [options, setOptions] = useState(
    value?.uuid
      ? [
          {
            uuid: value.uuid,
            label: getFullName(
              value.lastname,
              value.firstname,
              value.patronymic,
            ),
            ...value,
          },
        ]
      : [],
  );

  useEffect(() => {
    fetchOptions();

    // eslint-disable-next-line
  }, []);

  const fetchOptions = async () => {
    try {
      const { employees } = await getEmployeesOptions(
        { deleted: false },
        false, // isAdmins передать не можем, так как ответы у ручек не совпадают и используются для разных целей. Тут нужна обычная даже для админа
      );

      const options = employees.map((item) => ({
        ...item,
        label: getFullName(item.lastname, item.firstname, item.patronymic),
      }));

      // В опциях не приходят сотрудники которые удалены и уволены, но они могут быть выбраны в значении
      if (
        value?.uuid &&
        options.findIndex(({ uuid }) => uuid === value.uuid) === -1
      ) {
        const v = {
          ...value,
          label: getFullName(value.lastname, value.firstname, value.patronymic),
        };

        options.push(v);
      }

      setOptions(options);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    setVal(value?.uuid || value);
  }, [value]);

  return (
    <div>
      {label && <CustomLabel text={label} />}
      <CustomSelect
        value={val}
        placeholder={placeholder}
        showSearch
        allowClear
        fieldNames={{ value: "uuid" }}
        options={options}
        optionFilterProp="label"
        className="w-100"
        onChange={(selectedValue, option) => {
          const selectedOption = selectedValue ? option || null : null;

          const nextValue = returnObject
            ? selectedOption
              ? {
                  uuid: selectedOption.uuid,
                  lastname: selectedOption.lastname,
                  firstname: selectedOption.firstname,
                  patronymic: selectedOption.patronymic,
                  name: selectedOption.label,
                }
              : null
            : selectedOption?.uuid || null;

          onSubmit?.(nextValue);
          onComplete?.(nextValue);
        }}
        onInputKeyDown={(e) => {
          if (e.key !== "Enter") onKeyDown?.(e);
        }}
      />
    </div>
  );
};

export default InputEmployee;
